<div class="login-container d-flex">
  <!--Left Side-->
  <div class="left-side-panel">
    <img src="/assets/images/login-registration/LoginPageLogo.png" alt="" />
  </div>
  <!--Right Side-->
  <div class="right-side-login">
    <div class="content">
      <div class="panel-text mlb-text font-size-14">
        {{ 'login.welcome.message' | translate }}
      </div>
      <fgb-tm-user-login></fgb-tm-user-login>
    </div>
  </div>
</div>

<fgbcl-preview />
